import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'wai-subscription-contract-signing',
  templateUrl: './subscription-contract-signing.component.html',
  styleUrls: ['./subscription-contract-signing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SubscriptionContractSigningComponent implements OnChanges {
  @Input() public embedSource: string | null = null;
  @Input() public busy = false;
  @Input() public signingUnavailable = false;

  @Output() public continueClicked = new EventEmitter<void>();
  @Output() public retryClicked = new EventEmitter<void>();
  @Output() public cancelClicked = new EventEmitter<void>();

  public embedHtml: SafeHtml | null = null;
  public embedUrl: SafeResourceUrl | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['embedSource']) {
      this.updateEmbed(this.embedSource);
    }
  }

  public onContinue(): void {
    this.continueClicked.emit();
  }

  public onRetry(): void {
    this.retryClicked.emit();
  }

  public onCancel(): void {
    this.cancelClicked.emit();
  }

  private updateEmbed(value: string | null): void {
    this.embedHtml = null;
    this.embedUrl = null;
    if (!value) {
      return;
    }
    const trimmed = value.trim();
    const iframeSrc = this.extractIframeSrc(trimmed);
    if (iframeSrc) {
      this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeSrc);
      return;
    }
    if (/^https?:\/\//i.test(trimmed)) {
      this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(trimmed);
      return;
    }
    this.embedHtml = this.sanitizer.bypassSecurityTrustHtml(trimmed);
  }

  /** Signable often returns a full iframe tag; use its src in our sized iframe. */
  private extractIframeSrc(value: string): string | null {
    const match = value.match(/<iframe[^>]*\ssrc=["']([^"']+)["']/i);
    return match?.[1]?.trim() ?? null;
  }
}
